import { render, staticRenderFns } from "./DiagnoseInstance.vue?vue&type=template&id=33790ce2&scoped=true&"
import script from "./DiagnoseInstance.vue?vue&type=script&lang=js&"
export * from "./DiagnoseInstance.vue?vue&type=script&lang=js&"
import style0 from "./DiagnoseInstance.vue?vue&type=style&index=0&id=33790ce2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33790ce2",
  null
  
)

export default component.exports